import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './styles'

// Component that renders a hidden copy of content for export
// Uses zero-height container so it doesn't take visual space but html2canvas can still capture it
const HiddenExportCopy = ({ id, children, fullWidth = true }) => {
  const classes = useStyles({ fullWidth })

  return (
    <div className={classes.outerContainer}>
      <div id={id} className={classes.innerContainer}>
        {children}
      </div>
    </div>
  )
}

HiddenExportCopy.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool
}

export default HiddenExportCopy
